import { parseDate } from '@cyntox/common/ui';
import type { CountStatus, TargetSource } from '../api/types';

/** A local calendar date as the API writes it: yyyy-MM-dd. */
export function toIso(date: Date): string {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
}

export function addDays(iso: string, days: number): string {
  const date = parseDate(iso);
  date.setDate(date.getDate() + days);
  return toIso(date);
}

/** The Wednesday on or after a date: the week a count belongs to. */
export function weekEndingOf(iso: string): string {
  return addDays(iso, (3 - parseDate(iso).getDay() + 7) % 7);
}

/** This week and the ones before it, newest first. */
export function recentWeeks(currentWeekEnding: string, count = 13): string[] {
  return Array.from({ length: count }, (_, i) => addDays(currentWeekEnding, -7 * i));
}

export type Tone = 'good' | 'attention' | 'urgent' | 'neutral';

/** How a location's count for a period reads. "Missing" only once the period has closed. */
export function countStatus(status: CountStatus, isOpen: boolean): { label: string; tone: Tone } {
  switch (status) {
    case 'onTime': return { label: 'Reported', tone: 'good' };
    case 'late': return { label: 'Reported late', tone: 'attention' };
    case 'imported': return { label: 'From spreadsheet', tone: 'neutral' };
    default: return isOpen ? { label: 'Not yet', tone: 'neutral' } : { label: 'Missing', tone: 'urgent' };
  }
}

/** Where a minimum came from, in words. */
export const TARGET_SOURCE: Record<TargetSource, string> = {
  location: 'this location',
  group: 'group default',
  network: 'every location',
};
